import femaleChallengingAngryLong from "./femaleChallengingAngryLong.mp3";
import femaleChallengingAngryMedium from "./femaleChallengingAngryMedium.mp3";
import femaleChallengingAngryShort from "./femaleChallengingAngryShort.mp3";
import femaleChallengingHappyLong from "./femaleChallengingHappyLong.mp3";
import femaleChallengingHappyMedium from "./femaleChallengingHappyMedium.mp3";
import femaleChallengingHappyShort from "./femaleChallengingHappyShort.mp3";
import femaleChallengingNeutralLong from "./femaleChallengingNeutralLong.mp3";
import femaleChallengingNeutralMedium from "./femaleChallengingNeutralMedium.mp3";
import femaleChallengingNeutralShort from "./femaleChallengingNeutralShort.mp3";
import femaleConfidentAngryLong from "./femaleConfidentAngryLong.mp3";
import femaleConfidentAngryMedium from "./femaleConfidentAngryMedium.mp3";
import femaleConfidentAngryShort from "./femaleConfidentAngryShort.mp3";
import femaleConfidentHappyLong from "./femaleConfidentHappyLong.mp3";
import femaleConfidentHappyMedium from "./femaleConfidentHappyMedium.mp3";
import femaleConfidentHappyShort from "./femaleConfidentHappyShort.mp3";
import femaleConfidentNeutralLong from "./femaleConfidentNeutralLong.mp3";
import femaleConfidentNeutralMedium from "./femaleConfidentNeutralMedium.mp3";
import femaleConfidentNeutralShort from "./femaleConfidentNeutralShort.mp3";
import femaleConsistentAngryLong from "./femaleConsistentAngryLong.mp3";
import femaleConsistentAngryMedium from "./femaleConsistentAngryMedium.mp3";
import femaleConsistentAngryShort from "./femaleConsistentAngryShort.mp3";
import femaleConsistentHappyLong from "./femaleConsistentHappyLong.mp3";
import femaleConsistentHappyMedium from "./femaleConsistentHappyMedium.mp3";
import femaleConsistentHappyShort from "./femaleConsistentHappyShort.mp3";
import femaleConsistentNeutralLong from "./femaleConsistentNeutralLong.mp3";
import femaleConsistentNeutralMedium from "./femaleConsistentNeutralMedium.mp3";
import femaleConsistentNeutralShort from "./femaleConsistentNeutralShort.mp3";
import femaleCuriousAngryLong from "./femaleCuriousAngryLong.mp3";
import femaleCuriousAngryMedium from "./femaleCuriousAngryMedium.mp3";
import femaleCuriousAngryShort from "./femaleCuriousAngryShort.mp3";
import femaleCuriousHappyLong from "./femaleCuriousHappyLong.mp3";
import femaleCuriousHappyMedium from "./femaleCuriousHappyMedium.mp3";
import femaleCuriousHappyShort from "./femaleCuriousHappyShort.mp3";
import femaleCuriousNeutralLong from "./femaleCuriousNeutralLong.mp3";
import femaleCuriousNeutralMedium from "./femaleCuriousNeutralMedium.mp3";
import femaleCuriousNeutralShort from "./femaleCuriousNeutralShort.mp3";
import femaleEasyGoingAngryLong from "./femaleEasyGoingAngryLong.mp3";
import femaleEasyGoingAngryMedium from "./femaleEasyGoingAngryMedium.mp3";
import femaleEasyGoingAngryShort from "./femaleEasyGoingAngryShort.mp3";
import femaleEasyGoingHappyLong from "./femaleEasyGoingHappyLong.mp3";
import femaleEasyGoingHappyMedium from "./femaleEasyGoingHappyMedium.mp3";
import femaleEasyGoingHappyShort from "./femaleEasyGoingHappyShort.mp3";
import femaleEasyGoingNeutralLong from "./femaleEasyGoingNeutralLong.mp3";
import femaleEasyGoingNeutralMedium from "./femaleEasyGoingNeutralMedium.mp3";
import femaleEasyGoingNeutralShort from "./femaleEasyGoingNeutralShort.mp3";
import femaleFriendlyAngryLong from "./femaleFriendlyAngryLong.mp3";
import femaleFriendlyAngryMedium from "./femaleFriendlyAngryMedium.mp3";
import femaleFriendlyAngryShort from "./femaleFriendlyAngryShort.mp3";
import femaleFriendlyHappyLong from "./femaleFriendlyHappyLong.mp3";
import femaleFriendlyHappyMedium from "./femaleFriendlyHappyMedium.mp3";
import femaleFriendlyHappyShort from "./femaleFriendlyHappyShort.mp3";
import femaleFriendlyNeutralLong from "./femaleFriendlyNeutralLong.mp3";
import femaleFriendlyNeutralMedium from "./femaleFriendlyNeutralMedium.mp3";
import femaleFriendlyNeutralShort from "./femaleFriendlyNeutralShort.mp3";
import femaleOrganizedAngryLong from "./femaleOrganizedAngryLong.mp3";
import femaleOrganizedAngryMedium from "./femaleOrganizedAngryMedium.mp3";
import femaleOrganizedAngryShort from "./femaleOrganizedAngryShort.mp3";
import femaleOrganizedHappyLong from "./femaleOrganizedHappyLong.mp3";
import femaleOrganizedHappyMedium from "./femaleOrganizedHappyMedium.mp3";
import femaleOrganizedHappyShort from "./femaleOrganizedHappyShort.mp3";
import femaleOrganizedNeutralLong from "./femaleOrganizedNeutralLong.mp3";
import femaleOrganizedNeutralMedium from "./femaleOrganizedNeutralMedium.mp3";
import femaleOrganizedNeutralShort from "./femaleOrganizedNeutralShort.mp3";
import femaleOutgoingAngryLong from "./femaleOutgoingAngryLong.mp3";
import femaleOutgoingAngryMedium from "./femaleOutgoingAngryMedium.mp3";
import femaleOutgoingAngryShort from "./femaleOutgoingAngryShort.mp3";
import femaleOutgoingHappyLong from "./femaleOutgoingHappyLong.mp3";
import femaleOutgoingHappyMedium from "./femaleOutgoingHappyMedium.mp3";
import femaleOutgoingHappyShort from "./femaleOutgoingHappyShort.mp3";
import femaleOutgoingNeutralLong from "./femaleOutgoingNeutralLong.mp3";
import femaleOutgoingNeutralMedium from "./femaleOutgoingNeutralMedium.mp3";
import femaleOutgoingNeutralShort from "./femaleOutgoingNeutralShort.mp3";
import femaleReservedAngryLong from "./femaleReservedAngryLong.mp3";
import femaleReservedAngryMedium from "./femaleReservedAngryMedium.mp3";
import femaleReservedAngryShort from "./femaleReservedAngryShort.mp3";
import femaleReservedHappyLong from "./femaleReservedHappyLong.mp3";
import femaleReservedHappyMedium from "./femaleReservedHappyMedium.mp3";
import femaleReservedHappyShort from "./femaleReservedHappyShort.mp3";
import femaleReservedNeutralLong from "./femaleReservedNeutralLong.mp3";
import femaleReservedNeutralMedium from "./femaleReservedNeutralMedium.mp3";
import femaleReservedNeutralShort from "./femaleReservedNeutralShort.mp3";
import maleChallengingAngryLong from "./maleChallengingAngryLong.mp3";
import maleChallengingAngryMedium from "./maleChallengingAngryMedium.mp3";
import maleChallengingAngryShort from "./maleChallengingAngryShort.mp3";
import maleChallengingHappyLong from "./maleChallengingHappyLong.mp3";
import maleChallengingHappyMedium from "./maleChallengingHappyMedium.mp3";
import maleChallengingHappyShort from "./maleChallengingHappyShort.mp3";
import maleChallengingNeutralLong from "./maleChallengingNeutralLong.mp3";
import maleChallengingNeutralMedium from "./maleChallengingNeutralMedium.mp3";
import maleChallengingNeutralShort from "./maleChallengingNeutralShort.mp3";
import maleConfidentAngryLong from "./maleConfidentAngryLong.mp3";
import maleConfidentAngryMedium from "./maleConfidentAngryMedium.mp3";
import maleConfidentAngryShort from "./maleConfidentAngryShort.mp3";
import maleConfidentHappyLong from "./maleConfidentHappyLong.mp3";
import maleConfidentHappyMedium from "./maleConfidentHappyMedium.mp3";
import maleConfidentHappyShort from "./maleConfidentHappyShort.mp3";
import maleConfidentNeutralLong from "./maleConfidentNeutralLong.mp3";
import maleConfidentNeutralMedium from "./maleConfidentNeutralMedium.mp3";
import maleConfidentNeutralShort from "./maleConfidentNeutralShort.mp3";
import maleConsistentAngryLong from "./maleConsistentAngryLong.mp3";
import maleConsistentAngryMedium from "./maleConsistentAngryMedium.mp3";
import maleConsistentAngryShort from "./maleConsistentAngryShort.mp3";
import maleConsistentHappyLong from "./maleConsistentHappyLong.mp3";
import maleConsistentHappyMedium from "./maleConsistentHappyMedium.mp3";
import maleConsistentHappyShort from "./maleConsistentHappyShort.mp3";
import maleConsistentNeutralLong from "./maleConsistentNeutralLong.mp3";
import maleConsistentNeutralMedium from "./maleConsistentNeutralMedium.mp3";
import maleConsistentNeutralShort from "./maleConsistentNeutralShort.mp3";
import maleCuriousAngryLong from "./maleCuriousAngryLong.mp3";
import maleCuriousAngryMedium from "./maleCuriousAngryMedium.mp3";
import maleCuriousAngryShort from "./maleCuriousAngryShort.mp3";
import maleCuriousHappyLong from "./maleCuriousHappyLong.mp3";
import maleCuriousHappyMedium from "./maleCuriousHappyMedium.mp3";
import maleCuriousHappyShort from "./maleCuriousHappyShort.mp3";
import maleCuriousNeutralLong from "./maleCuriousNeutralLong.mp3";
import maleCuriousNeutralMedium from "./maleCuriousNeutralMedium.mp3";
import maleCuriousNeutralShort from "./maleCuriousNeutralShort.mp3";
import maleEasyGoingAngryLong from "./maleEasyGoingAngryLong.mp3";
import maleEasyGoingAngryMedium from "./maleEasyGoingAngryMedium.mp3";
import maleEasyGoingAngryShort from "./maleEasyGoingAngryShort.mp3";
import maleEasyGoingHappyLong from "./maleEasyGoingHappyLong.mp3";
import maleEasyGoingHappyMedium from "./maleEasyGoingHappyMedium.mp3";
import maleEasyGoingHappyShort from "./maleEasyGoingHappyShort.mp3";
import maleEasyGoingNeutralLong from "./maleEasyGoingNeutralLong.mp3";
import maleEasyGoingNeutralMedium from "./maleEasyGoingNeutralMedium.mp3";
import maleEasyGoingNeutralShort from "./maleEasyGoingNeutralShort.mp3";
import maleFriendlyAngryLong from "./maleFriendlyAngryLong.mp3";
import maleFriendlyAngryMedium from "./maleFriendlyAngryMedium.mp3";
import maleFriendlyAngryShort from "./maleFriendlyAngryShort.mp3";
import maleFriendlyHappyLong from "./maleFriendlyHappyLong.mp3";
import maleFriendlyHappyMedium from "./maleFriendlyHappyMedium.mp3";
import maleFriendlyHappyShort from "./maleFriendlyHappyShort.mp3";
import maleFriendlyNeutralLong from "./maleFriendlyNeutralLong.mp3";
import maleFriendlyNeutralMedium from "./maleFriendlyNeutralMedium.mp3";
import maleFriendlyNeutralShort from "./maleFriendlyNeutralShort.mp3";
import maleOrganizedAngryLong from "./maleOrganizedAngryLong.mp3";
import maleOrganizedAngryMedium from "./maleOrganizedAngryMedium.mp3";
import maleOrganizedAngryShort from "./maleOrganizedAngryShort.mp3";
import maleOrganizedHappyLong from "./maleOrganizedHappyLong.mp3";
import maleOrganizedHappyMedium from "./maleOrganizedHappyMedium.mp3";
import maleOrganizedHappyShort from "./maleOrganizedHappyShort.mp3";
import maleOrganizedNeutralLong from "./maleOrganizedNeutralLong.mp3";
import maleOrganizedNeutralMedium from "./maleOrganizedNeutralMedium.mp3";
import maleOrganizedNeutralShort from "./maleOrganizedNeutralShort.mp3";
import maleOutgoingAngryLong from "./maleOutgoingAngryLong.mp3";
import maleOutgoingAngryMedium from "./maleOutgoingAngryMedium.mp3";
import maleOutgoingAngryShort from "./maleOutgoingAngryShort.mp3";
import maleOutgoingHappyLong from "./maleOutgoingHappyLong.mp3";
import maleOutgoingHappyMedium from "./maleOutgoingHappyMedium.mp3";
import maleOutgoingHappyShort from "./maleOutgoingHappyShort.mp3";
import maleOutgoingNeutralLong from "./maleOutgoingNeutralLong.mp3";
import maleOutgoingNeutralMedium from "./maleOutgoingNeutralMedium.mp3";
import maleOutgoingNeutralShort from "./maleOutgoingNeutralShort.mp3";
import maleReservedAngryLong from "./maleReservedAngryLong.mp3";
import maleReservedAngryMedium from "./maleReservedAngryMedium.mp3";
import maleReservedAngryShort from "./maleReservedAngryShort.mp3";
import maleReservedHappylLong from "./maleReservedHappylLong.mp3";
import maleReservedHappyMedium from "./maleReservedHappyMedium.mp3";
import maleReservedHappyShort from "./maleReservedHappyShort.mp3";
import maleReservedNeutralLong from "./maleReservedNeutralLong.mp3";
import maleReservedNeutralMedium from "./maleReservedNeutralMedium.mp3";
import maleReservedNeutralShort from "./maleReservedNeutralShort.mp3";

export default {
    femaleChallengingAngryLong,
    femaleChallengingAngryMedium,
    femaleChallengingAngryShort,
    femaleChallengingHappyLong,
    femaleChallengingHappyMedium,
    femaleChallengingHappyShort,
    femaleChallengingNeutralLong,
    femaleChallengingNeutralMedium,
    femaleChallengingNeutralShort,
    femaleConfidentAngryLong,
    femaleConfidentAngryMedium,
    femaleConfidentAngryShort,
    femaleConfidentHappyLong,
    femaleConfidentHappyMedium,
    femaleConfidentHappyShort,
    femaleConfidentNeutralLong,
    femaleConfidentNeutralMedium,
    femaleConfidentNeutralShort,
    femaleConsistentAngryLong,
    femaleConsistentAngryMedium,
    femaleConsistentAngryShort,
    femaleConsistentHappyLong,
    femaleConsistentHappyMedium,
    femaleConsistentHappyShort,
    femaleConsistentNeutralLong,
    femaleConsistentNeutralMedium,
    femaleConsistentNeutralShort,
    femaleCuriousAngryLong,
    femaleCuriousAngryMedium,
    femaleCuriousAngryShort,
    femaleCuriousHappyLong,
    femaleCuriousHappyMedium,
    femaleCuriousHappyShort,
    femaleCuriousNeutralLong,
    femaleCuriousNeutralMedium,
    femaleCuriousNeutralShort,
    femaleEasyGoingAngryLong,
    femaleEasyGoingAngryMedium,
    femaleEasyGoingAngryShort,
    femaleEasyGoingHappyLong,
    femaleEasyGoingHappyMedium,
    femaleEasyGoingHappyShort,
    femaleEasyGoingNeutralLong,
    femaleEasyGoingNeutralMedium,
    femaleEasyGoingNeutralShort,
    femaleFriendlyAngryLong,
    femaleFriendlyAngryMedium,
    femaleFriendlyAngryShort,
    femaleFriendlyHappyLong,
    femaleFriendlyHappyMedium,
    femaleFriendlyHappyShort,
    femaleFriendlyNeutralLong,
    femaleFriendlyNeutralMedium,
    femaleFriendlyNeutralShort,
    femaleOrganizedAngryLong,
    femaleOrganizedAngryMedium,
    femaleOrganizedAngryShort,
    femaleOrganizedHappyLong,
    femaleOrganizedHappyMedium,
    femaleOrganizedHappyShort,
    femaleOrganizedNeutralLong,
    femaleOrganizedNeutralMedium,
    femaleOrganizedNeutralShort,
    femaleOutgoingAngryLong,
    femaleOutgoingAngryMedium,
    femaleOutgoingAngryShort,
    femaleOutgoingHappyLong,
    femaleOutgoingHappyMedium,
    femaleOutgoingHappyShort,
    femaleOutgoingNeutralLong,
    femaleOutgoingNeutralMedium,
    femaleOutgoingNeutralShort,
    femaleReservedAngryLong,
    femaleReservedAngryMedium,
    femaleReservedAngryShort,
    femaleReservedHappyLong,
    femaleReservedHappyMedium,
    femaleReservedHappyShort,
    femaleReservedNeutralLong,
    femaleReservedNeutralMedium,
    femaleReservedNeutralShort,
    maleChallengingAngryLong,
    maleChallengingAngryMedium,
    maleChallengingAngryShort,
    maleChallengingHappyLong,
    maleChallengingHappyMedium,
    maleChallengingHappyShort,
    maleChallengingNeutralLong,
    maleChallengingNeutralMedium,
    maleChallengingNeutralShort,
    maleConfidentAngryLong,
    maleConfidentAngryMedium,
    maleConfidentAngryShort,
    maleConfidentHappyLong,
    maleConfidentHappyMedium,
    maleConfidentHappyShort,
    maleConfidentNeutralLong,
    maleConfidentNeutralMedium,
    maleConfidentNeutralShort,
    maleConsistentAngryLong,
    maleConsistentAngryMedium,
    maleConsistentAngryShort,
    maleConsistentHappyLong,
    maleConsistentHappyMedium,
    maleConsistentHappyShort,
    maleConsistentNeutralLong,
    maleConsistentNeutralMedium,
    maleConsistentNeutralShort,
    maleCuriousAngryLong,
    maleCuriousAngryMedium,
    maleCuriousAngryShort,
    maleCuriousHappyLong,
    maleCuriousHappyMedium,
    maleCuriousHappyShort,
    maleCuriousNeutralLong,
    maleCuriousNeutralMedium,
    maleCuriousNeutralShort,
    maleEasyGoingAngryLong,
    maleEasyGoingAngryMedium,
    maleEasyGoingAngryShort,
    maleEasyGoingHappyLong,
    maleEasyGoingHappyMedium,
    maleEasyGoingHappyShort,
    maleEasyGoingNeutralLong,
    maleEasyGoingNeutralMedium,
    maleEasyGoingNeutralShort,
    maleFriendlyAngryLong,
    maleFriendlyAngryMedium,
    maleFriendlyAngryShort,
    maleFriendlyHappyLong,
    maleFriendlyHappyMedium,
    maleFriendlyHappyShort,
    maleFriendlyNeutralLong,
    maleFriendlyNeutralMedium,
    maleFriendlyNeutralShort,
    maleOrganizedAngryLong,
    maleOrganizedAngryMedium,
    maleOrganizedAngryShort,
    maleOrganizedHappyLong,
    maleOrganizedHappyMedium,
    maleOrganizedHappyShort,
    maleOrganizedNeutralLong,
    maleOrganizedNeutralMedium,
    maleOrganizedNeutralShort,
    maleOutgoingAngryLong,
    maleOutgoingAngryMedium,
    maleOutgoingAngryShort,
    maleOutgoingHappyLong,
    maleOutgoingHappyMedium,
    maleOutgoingHappyShort,
    maleOutgoingNeutralLong,
    maleOutgoingNeutralMedium,
    maleOutgoingNeutralShort,
    maleReservedAngryLong,
    maleReservedAngryMedium,
    maleReservedAngryShort,
    maleReservedHappylLong,
    maleReservedHappyMedium,
    maleReservedHappyShort,
    maleReservedNeutralLong,
    maleReservedNeutralMedium,
    maleReservedNeutralShort,
};